class FtdSpecialRequest extends HTMLElement {
  connectedCallback() {
    if (this.bound) return;
    this.bound = true;
    this.querySelector('button').addEventListener('click', () => this.addRequest());
  }

  async addRequest() {
    if (this.pending) return;
    const input = this.querySelector('textarea');
    const button = this.querySelector('button');
    const error = this.querySelector('[role="alert"]');
    const note = input.value.trim();
    error.hidden = true;
    input.removeAttribute('aria-invalid');
    if (!note) {
      error.textContent = 'Please describe your special request first.';
      error.hidden = false;
      input.setAttribute('aria-invalid', 'true');
      input.focus();
      return;
    }

    this.pending = true;
    button.disabled = true;
    this.setAttribute('aria-busy', 'true');
    const originalLabel = button.textContent;
    button.textContent = 'Adding request…';
    try {
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{
          id: this.dataset.variantId,
          quantity: 1,
          properties: {
            _LinkedItemKey: this.dataset.linkedKey,
            _LinkedItemTitle: this.dataset.linkedTitle,
            _Request: note,
            'For item': this.dataset.linkedTitle,
            Request: note,
          },
        }] }),
      });
      const result = await response.json();
      if (!response.ok || result.status) {
        throw new Error(typeof result.description === 'string' ? result.description : 'Unable to add your request. Please try again.');
      }
      // Reload only after Shopify confirms the addition, keeping all cart totals in sync.
      window.location.reload();
    } catch (failure) {
      error.textContent = failure instanceof TypeError
        ? 'We could not confirm the addition. Refresh your cart before trying again.'
        : failure.message || 'Unable to add your request. Please try again.';
      error.hidden = false;
      this.pending = false;
      button.disabled = false;
      button.textContent = originalLabel;
      this.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('ftd-special-request')) {
  customElements.define('ftd-special-request', FtdSpecialRequest);
}
